import * as React from 'react';
import { connect } from 'react-redux';
import './qnot.css';
import DataTable from '../DataTable';
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { Modal, Button } from 'react-bootstrap';
import { GetURIByParts } from '../../services/Utils/StringUtils';
import NotificationEditForm from './NotificationEditForm';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';
import { INotification, NotificationStatus } from '../../common/sharedTypes';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import './qnot.css';
import {
  getNotifications,
  saveUpdatedNotification,
  sendNotifications,
  removeNotifications,
} from './redux-objects/actions';
import AdhocNotificationButton from '../Notifications/AdhocNotification/AdhocNotificationButton';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IQueuedNotificationsActionProps {
  getNotifications?: (url: string) => void;
  sendNotifications?: (
    url: string,
    notifications: INotification[],
    ids: any[]
  ) => void;
  removeNotifications?: (url: string, ids: any[]) => void;
  saveUpdatedNotification: (url: string, notification: INotification) => void;
}

interface IQueuedNotificationsStateProps {
  notifications: INotification[];
  webServiceURL: string;
  isProcessing: boolean;
}

interface IQueuedNotificationProps
  extends IQueuedNotificationsActionProps,
    IQueuedNotificationsStateProps {}

enum ModalMode {
  None,
  New,
  Editing,
}

enum ServiceEndPoints {
  GetNotifications = 'GetNotifications',
  PutNotification = 'PutNotification',
  SendNotifications = 'SendNotifications',
  RemoveNotifications = 'RemoveNotifications',
}

const initialState = {
  userOnly: true,
  startDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ), // moment('1/2/2019', 'DD/MM/YYYY'),
  endDate: moment(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'), //moment('28/2/2019', 'DD/MM/YYYY'),
  notificationTypeId: '-1',
  reportTypeId: '-1',
  focusedInput: null,
  showModal: false,
  modalStatus: ModalMode.None,
  currentNotification: null,
};
type QueuedNotificationState = Readonly<typeof initialState>;

class QueuedNotifications extends React.Component<
  IQueuedNotificationProps,
  QueuedNotificationState
> {
  private editForm: any = React.createRef();

  public constructor(props: IQueuedNotificationProps) {
    super(props);
    this.state = initialState;
  }

  // TODO: Refactor to configuration file
  private notificationServiceController: string = 'Notification';

  componentDidMount() {
    this.populateNotifications();
  }

  closeModal = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false,
      currentNotification: null,
    });
  };

  toggleScrollLock = () => {
    document.querySelector('html').classList.toggle('scroll-lock');
  };

  handleSendSelected(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    const selected = $('#tblQueuedNotifications')
      .DataTable()
      .rows({ selected: true });
    if (selected.data().length === 0) {
      toast.error('No Notificaitons Selected');
      return;
    }
    const ids = [];
    $(selected.data()).each(function (index, data) {
      ids.push(data.id);
    });

    // Add to sent notifications list
    const notifications = [];
    $('#tblQueuedNotifications')
      .DataTable()
      .rows({ selected: true })
      .data()
      .each(function (value, index) {
        console.log(value);
        notifications.push(value);
      });

    this.props.sendNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.SendNotifications
      ),
      notifications,
      ids
    );

    // optimistic remove
    $('#tblQueuedNotifications')
      .DataTable()
      .rows({ selected: true })
      .remove()
      .draw();
  }

  handleSendOne(event: React.MouseEvent<HTMLElement>, row: any) {
    const notificationId = event;
    let indexToRemove = -1;
    $('#tblQueuedNotifications')
      .DataTable()
      .rows(function (idx, data, node) {
        if (data.id == notificationId) {
          indexToRemove = idx;
        }
        return false;
      });
    const notification = $('#tblQueuedNotifications')
      .DataTable()
      .rows(indexToRemove)
      .data();

    this.props.sendNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.SendNotifications
      ),
      [notification[0]],
      [notificationId]
    );
  }

  handleRemoveOne(event: React.MouseEvent<HTMLElement>, row: any) {
    const notificationId = event;

    this.props.removeNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.RemoveNotifications
      ),
      [notificationId]
    );
  }
  handleRemoveSelected(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    const selected = $('#tblQueuedNotifications')
      .DataTable()
      .rows({ selected: true });
    if (selected.data().length === 0) {
      toast.error('No Letters Selected');
      return;
    }
    const ids = [];
    $(selected.data()).each(function (index, data) {
      ids.push(data.id);
    });

    this.props.removeNotifications(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.RemoveNotifications
      ),
      ids
    );
  }

  handleEdit(event: any, row: any) {
    const notificationId = event;
    const currN: INotification = this.props.notifications.find(
      (notification) => notification.id == notificationId
    );
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.Editing,
      showModal: true,
      currentNotification: currN,
    });
  }

  handleUserCheck(userChecked) {
    this.setState({ userOnly: userChecked }, () => {
      this.populateNotifications();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.populateNotifications();
      });
    }
  }

  handleNotificationTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ notificationTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  handleReportTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState({ reportTypeId: value }, () => {
      this.populateNotifications();
    });
  }

  refreshNotifications() {
    this.populateNotifications();
  }
  populateNotifications() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.notificationServiceController,
      ServiceEndPoints.GetNotifications
    );

    var params = {
      userOnly: this.state.userOnly,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      notificationTypeId: this.state.notificationTypeId,
      reportTypeId: this.state.reportTypeId,
      statusId: NotificationStatus.QUEUED,
      reportsOnly: 'true',
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    this.props.getNotifications(uri);
  }

  onSaveNotification = async (e) => {
    let updatedNotification: INotification = this.editForm.getUpdatedNotification();

    await this.props.saveUpdatedNotification(
      GetURIByParts(
        this.props.webServiceURL,
        this.notificationServiceController,
        ServiceEndPoints.PutNotification
      ),
      updatedNotification
    );

    this.closeModal();
    toast.success('Saved!');
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '350px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleSendOne(cellData, row)}
              >
                {' '}
                Send
              </Button>
              {'  '}
              <Button
                variant='outline-warning'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleEdit(cellData, row)}
              >
                {' '}
                Edit{' '}
              </Button>
              {'  '}
              <Button
                variant='outline-danger'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleRemoveOne(cellData, row)}
              >
                {' '}
                Remove{' '}
              </Button>
            </div>,
            td
          ),
      },
      {
        targets: 1,
        render: function (data) {
          return moment(data).format('dddd, MMMM Do, YYYY'); // ('MMMM Do YYYY');
        },
      },
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'id',
      },
      {
        title: 'Date Requested',
        data: 'createdDate',
      },
      {
        title: 'Template',
        data: 'notificationTemplate.name',
      },
      {
        title: 'Subject',
        data: 'subject',
      },
      {
        title: 'Sent To',
        data: 'sendTo',
      },
      {
        title: 'Requested By',
        mData: function (data, type, dataToSet) {
          return (
            data.createdByUser.firstName + ' ' + data.createdByUser.lastName
          );
        },
      },
      {
        title: 'Letter Type',
        mData: function (data, type, dataToSet) {
          return (
            (data.notificationType && data.notificationType.name) || 'unknown'
          );
        },
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
      select: 'multi',
      dom: 'frtipB'
    };

    return (
      <div className='app'>
        <div className='row'>
          <div className='col-sm-6'>
            <h3>Queued Letters</h3>
          </div>
          <div className='col-sm-6'>
            <AdhocNotificationButton
              className='float-right'
              onSave={() => this.refreshNotifications()}
            />
          </div>
        </div>

        <hr />
        <Form>
          <Form.Group controlId='formBasicCheckbox'>
            <Form.Check
              type='checkbox'
              label=' Show only Letters I created'
              defaultChecked
              onChange={(e) => this.handleUserCheck(e.target.checked)}
            />
          </Form.Group>
          <Form.Row>
            <Form.Group as={Col} controlId='queuedNotificationsStartDate'>
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId='queuedNotificationsStartDate' // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId='queuedNotificationsEndDate' // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='exampleForm.ControlSelect1'>
              <Form.Label>Letter Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleNotificationTypeChange(e)}
                value={this.state.notificationTypeId}
                type={LookupValueTypes.NOTIFICATION_TYPES}
                includeAll={true}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='exampleForm.ControlSelect2'>
              <Form.Label>Report Type</Form.Label>
              <LookupValueSelectList
                onChange={(e) => this.handleReportTypeChange(e)}
                value={this.state.reportTypeId}
                type={LookupValueTypes.REPORT_TYPES}
                includeAll={true}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row />
          <Form.Row>
            <Form.Group as={Col}>
              <Button
                id='btnSendSelected'
                type='button'
                className='btn btn-primary'
                onClick={(e) => this.handleSendSelected(e)}
              >
                Send Selected
              </Button>
              {'   '}
              <Button
                id='btnRemoveSelected'
                type='button'
                className='btn btn-danger'
                onClick={(e) => this.handleRemoveSelected(e)}
              >
                Remove Selected
              </Button>
            </Form.Group>
          </Form.Row>
        </Form>
        <DataTable
          id='tblQueuedNotifications'
          data={this.props.notifications}
          columns={columns}
          columnDefs={columnDefs}
          actionsColumn='first'
          {...options}
        />
        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {' '}
              {this.state.modalStatus == ModalMode.New
                ? 'Create Notification'
                : 'Edit Notification'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <NotificationEditForm
              notificationToEdit={this.state.currentNotification}
              ref={(ef) => (this.editForm = ef)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.closeModal}>
              Close
            </Button>
            <Button variant='primary' onClick={this.onSaveNotification}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    notifications: state.qnotification.notifications,
    webServiceURL: state.Application.backendURL,
  };
}

const mapDispatchToProps = {
  getNotifications,
  saveUpdatedNotification,
  sendNotifications,
  removeNotifications,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QueuedNotifications);
